
// import { nationalFormatPhone } from '../../utils/FormatPhoneNumber/FormatPhoneNumber'
import { Button, Ellipsis } from 'antd-mobile'
import { CloseOutline, DownFill } from 'antd-mobile-icons'
import decodeHtmlEntities from '../../utils/UnexcapeString/UnexcapeString'
const ClientCard = (props) => {
    const { currentClient, isEdit, isHideClientPhoneNumber } = props
    const clientName = currentClient.firstName || currentClient.lastName ? currentClient.firstName + " " + currentClient.lastName : 'Unknown'
    const onClose = () => {
        props.setCurrentClient(null)
    }

    return (
        <div style={{ padding: '12px', backgroundColor: 'white', borderRadius: '8px', margin: '0px 12px', position: 'relative' }}>
            {!isEdit && <Button
                onClick={onClose}
                fill='none'
                color='danger'
                style={{
                    position: 'absolute',
                    top: '0px',
                    right: '0px',
                    // fontSize: '16px',
                }}
            >
                <CloseOutline />
            </Button>}
            <h3 style={{ fontSize: "18px" }}>{decodeHtmlEntities(clientName)}</h3>
            <div style={{ margin: "8px 0px 8px 0px" }}>{isHideClientPhoneNumber && currentClient.phone ? <span>•••• {currentClient.phone?.slice(-4)}</span> : <a style={{ fontWeight: "bold", fontSize: "16px", }} href={`tel:${currentClient.phone}`} rel="noreferrer"><span>•••• {currentClient.phone?.slice(-4)}</span></a>}</div>
            {/* <div>{currentClient.email}</div> */}
            {currentClient.note && <Ellipsis
                content={decodeHtmlEntities(currentClient.note)}
                direction='end'
                rows={2} // or however many lines you want to show before truncating
                expandText={<DownFill />}
                collapseText={<DownFill style={{ transform: 'rotate(180deg)', marginLeft: "5px" }} />}
                style={{ color: '#d46b08', fontWeight: 'bold' }}
            />}
        </div>
    )
}

export default ClientCard